export function shortenText(text: string): string {
    console.log({ text })
    if (text.length <= 8) {
        return text; // Retorna o texto original se tiver 8 ou menos caracteres
    }
    return text.slice(0, 8) + "..."; // Mantém as primeiras 8 letras e adiciona "..."
}